import { COLOR_SYSTEM } from "components/design/design-system";
import { typography } from "components/design/typography";
import React from "react";
import styled from "styled-components";

export type BadgeColor = "Primary" | "Red" | "Black" | "Gray";

export interface BadgeProps {
  /** Badge 안에 들어갈 내용 */
  content?: string;
  /** Badge 색상 */
  color: BadgeColor;
  /** Custom inline CSS */
  style?: React.CSSProperties;
  /** className */
  className?: string;
}

const BadgeWrapper = styled.span<BadgeProps>`
  display: inline-block;
  padding: ${({ content }) =>
    content && content.length > 1 ? "0px 6px" : "0px"};
  min-width: ${({ content }) => (content ? "20px" : "8px")};
  height: ${({ content }) => (content ? "20px" : "8px")};
  color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  background-color: ${({ color }) => {
    const backgroundColorMap = {
      Primary: COLOR_SYSTEM.get("Skyblue")?.[400],
      Red: COLOR_SYSTEM.get("Red")?.[300],
      Black: COLOR_SYSTEM.get("Gray")?.[900],
      Gray: COLOR_SYSTEM.get("Gray")?.[100],
    };

    return backgroundColorMap[color];
  }};
  border-radius: 999px;
  text-align: center;
  box-sizing: border-box;
  ${typography.get("CaptionBold")};
  line-height: 20px;
`;

const Badge = ({ content = "", color, style, className }: BadgeProps) => {
  return (
    <BadgeWrapper
      color={color}
      content={content}
      style={style}
      className={className}
    >
      {content}
    </BadgeWrapper>
  );
};

export default Badge;
